// extracted by mini-css-extract-plugin
module.exports = {"card":"styles_card__BATUo","pulse":"styles_pulse__xCUqQ","jump":"styles_jump__8QGvS"};